import React from 'react';

function getSeasonImage(locale) {
    const currentDate = new Date();
    const month = currentDate.getMonth() + 1; // Le mois actuel (1 à 12)
    const day = currentDate.getDate();      // Le jour actuel (1 à 31)
    let imageName = '';

    // Début de l'Automne (16 mars)
    const isAfterStartAutomn = (month > 3) || (month === 3 && day >= 16);

    // Fin de l'Automne (15 novembre)
    const isBeforeEndAutomn = (month < 11) || (month === 11 && day <= 15);

    // ## PÉRIODE 1 : AUTOMNE (16 mars au 15 novembre)
    if (isAfterStartAutomn && isBeforeEndAutomn) {
        imageName = 'Automn';
    }
    // ## PÉRIODE 2 : HIVER (16 novembre au 15 mars)
    else if (
        // Cas 1 : Après le 16 novembre (jusqu'à la fin de l'année)
        (month === 11 && day >= 16) ||
        (month === 12) ||
        // Cas 2 : Avant le 15 mars (début de l'année)
        (month < 3) ||
        (month === 3 && day <= 15)
    ) {
        imageName = 'Winter';
    }
    // ## PÉRIODE 3 : ÉTÉ (Option de Secours)
    else {
        // Cette condition sera techniquement jamais atteinte car
        // Automne et Hiver couvrent toute l'année avec vos dates.
        imageName = 'Summer';
    }

    // Ajout du suffixe de locale (ex: Automn-fr)
    if (locale === 'fr' || locale === 'en') {
        imageName += `-${locale}`;
    }

    return (
        <img src={require(`./Images/${imageName}.jpg`)} alt="Image accueil" />
    );
}

export default getSeasonImage;